import { render, staticRenderFns } from "./notice-ticker.vue?vue&type=template&id=5d987394&scoped=true&"
import script from "./notice-ticker.vue?vue&type=script&lang=js&"
export * from "./notice-ticker.vue?vue&type=script&lang=js&"
import style0 from "./notice-ticker.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./notice-ticker.vue?vue&type=style&index=1&id=5d987394&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5d987394",
  null
  
)

export default component.exports